var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9812 30.1875L31.0625 24.15L29.225 22.3125L24.9812 26.4688L23.275 24.7625L21.4375 26.6438L24.9812 30.1875ZM5.25 10.5H26.25V7H5.25V10.5ZM26.25 35C23.8292 35 21.7659 34.1466 20.0603 32.4398C18.3546 30.7329 17.5012 28.6697 17.5 26.25C17.5 23.8292 18.3534 21.7659 20.0603 20.0603C21.7671 18.3546 23.8303 17.5012 26.25 17.5C28.6708 17.5 30.7347 18.3534 32.4415 20.0603C34.1483 21.7671 35.0012 23.8303 35 26.25C35 28.6708 34.1466 30.7347 32.4398 32.4415C30.7329 34.1483 28.6697 35.0012 26.25 35ZM0 33.25V0H31.5V15.1813C30.6833 14.7729 29.8299 14.4737 28.9398 14.2835C28.0496 14.0933 27.153 13.9988 26.25 14H5.25V17.5H17.675C17.1792 17.9958 16.7201 18.5354 16.2977 19.1187C15.8754 19.7021 15.5033 20.3292 15.1813 21H5.25V24.5H14.1312C14.0729 24.7917 14.0367 25.0763 14.0227 25.354C14.0087 25.6317 14.0012 25.9303 14 26.25C14 27.475 14.168 28.6493 14.504 29.7728C14.84 30.8963 15.3428 31.9678 16.0125 32.9875L15.75 33.25L13.125 30.625L10.5 33.25L7.875 30.625L5.25 33.25L2.625 30.625L0 33.25Z",
    fill: "#56A74A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder);
export default __webpack_public_path__ + "static/media/Order.5fa236c2b9106a29426e432f07a9fe20.svg";
export { ForwardRef as ReactComponent };